module.exports = __webpack_public_path__ + "img/coronareader.com.2bb1430f.png";